var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"is-flex align-center",class:{
    'flex-column': _vm.column === true
  }},[_c('icon',{class:{
      'has-text-danger': _vm.count > 0,
      'has-text-success': _vm.count === 0,
    },attrs:{"icon":_vm.count > 0 ? 'exclamation-triangle' : 'check-circle',"type":_vm.count > 0 ? 'fas' : 'far'}}),_c('span',[_c('span',[_vm._v(_vm._s(_vm.count)+" Problem")]),(_vm.count !== 1)?_c('span',[_vm._v("s")]):_vm._e()])],1)}
var staticRenderFns = []

export { render, staticRenderFns }